var _path, _path2, _path3, _path4, _path5, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterHeadBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 789,
    height: 130,
    viewBox: "0 0 789 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 41.5C72.6349 10.5574 0.5 0 0.5 0L0 129.5H140.5C140.5 129.5 128.496 68.4342 102.5 41.5Z",
    fill: "#20283B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M759 78.1112V103.611H613C613 103.611 683.5 80.6113 718 78.1112C752.5 75.6111 759 78.1112 759 78.1112Z",
    fill: "#20283B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.053 41.107C152.638 27.5269 48 84.034 48 84.034V104H459C459 104 271.346 51.0901 221.053 41.107Z",
    fill: "#20283B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160 41.1106C96.7451 27.5073 0 84.1106 0 84.1106V104.111H380C380 104.111 206.5 51.1107 160 41.1106Z",
    fill: "#16A9BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M788.5 78.4999V104H642.5C642.5 104 713 81 747.5 78.4999C782 75.9998 788.5 78.4999 788.5 78.4999Z",
    fill: "#16A9BD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 104,
    width: 789,
    height: 26,
    fill: "#20283B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterHeadBottom);
export default __webpack_public_path__ + "static/media/LetterHeadBottom.148181e4b92285a1cc22db01ed4b0ed4.svg";
export { ForwardRef as ReactComponent };